import React from "react";
import { PeekList, PeekStack } from "@piiqtechnologies/ui-components";
export const RankingWidgetShell = ({ id, chart, isEmpty, children }) => {
    return (React.createElement(PeekStack, { id: id, sx: Object.assign({}, (isEmpty && { minHeight: 670 })) },
        React.createElement(PeekStack, { spacing: 2, sx: { flex: 1 } },
            chart,
            React.createElement(PeekStack, { sx: { listStyle: "none", p: 0, m: 0, flex: isEmpty ? 1 : undefined } },
                React.createElement(PeekList, { sx: Object.assign({ listStyle: "none", p: 0, m: 0, display: "flex", flexDirection: "column", flex: 1 }, (isEmpty
                        ? {
                            gap: 3,
                            justifyContent: "space-between",
                            "& > li": { py: 2, flex: 1, display: "flex", alignItems: "center", minHeight: 100 },
                        }
                        : {
                            "& > li:not(:first-of-type)": { pt: 1 },
                            "& > li:not(:last-of-type)": { pb: 1, borderBottom: 1, borderColor: "divider" },
                        })) }, children)))));
};
export default RankingWidgetShell;
